import { QueryResult, useQuery } from '@apollo/client'
import {
  Country,
  GetAppraisalsWithFeedbackToResolveCounterByCountryQuery,
  GetAppraisalsWithFeedbackToResolveCounterByCountryQueryVariables,
} from '../../../types'
import { APPRAISALS_WITH_FEEDBACK_COUNTER_BY_COUNTRY } from '../MeetingQueries'

export const useAppraisalsWithFeedbackCounter = (
  country: Country,
): QueryResult<
  GetAppraisalsWithFeedbackToResolveCounterByCountryQuery,
  GetAppraisalsWithFeedbackToResolveCounterByCountryQueryVariables
> => {
  return useQuery<
    GetAppraisalsWithFeedbackToResolveCounterByCountryQuery,
    GetAppraisalsWithFeedbackToResolveCounterByCountryQueryVariables
  >(APPRAISALS_WITH_FEEDBACK_COUNTER_BY_COUNTRY, {
    variables: {
      country,
    },
    fetchPolicy: 'network-only',
  })
}
